<template>
  <div class="video-view">
    <div class="video-item-view" v-for="(item,index) in videoList" :key="index">
      <el-divider content-position="center" v-if="false">视频信息</el-divider>
      <div class="publisher-view">
        发布人: {{item.platformUserName}}
      </div>
      <div class="video-title">
        视频标题: {{item.videoTitle}}
      </div>
      <div class="video-title-view">
        <div class="video-text">视频简介: {{item.videoText}}</div>
        <!--<el-collapse>
          <el-collapse-item :title="'视频标题'+item.videoTitle">

          </el-collapse-item>
        </el-collapse>-->
      </div>
      <div class="video-item">
        <vueMiniPlayer ref="vueMiniPlayer"
                       :video="item.videoItem" :mutex="true"
                       @fullscreen="handleFullscreen" />
      </div>
      <div class="video-bottom">
        <div class="bottom-show-view">
          <div class="bottom-show-item">
            <el-tag type="primary">平均评分:{{item.starNum}}</el-tag>
          </div>
          <div class="bottom-show-item">
            <el-tag type="primary">评论数量:{{item.commentNum}}</el-tag>
          </div>
        </div>
        <div class="bottom-handle-view">
          <div class="bottom-handle-item">
            <el-badge :value="item.tagNum" class="item">
              <el-button size="mini" @click="videoTag(item)">点赞</el-button>
            </el-badge>
          </div>
          <div class="bottom-handle-item">
            <el-button size="mini" @click="downloadVideo(item)">下载视频</el-button>
          </div>
          <div class="bottom-handle-item">
            <el-button size="mini" @click="showCommentView(item)">评论视频</el-button>
          </div>
          <div class="bottom-handle-item">
            <el-button size="mini" @click="showCommentDrawer(item)">查看评论</el-button>
          </div>
          <div class="bottom-handle-item">
            <el-button size="mini" @click="showVideoTransmit(item)">转发视频</el-button>
          </div>
          <div class="bottom-handle-item">
            <el-button size="mini" @click="handleDeleteVideo(item)">删除视频</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
        title="视频评论内容"
        :visible.sync="commentDrawerShow"
        :direction="commentDrawerDirection"
        :before-close="handleDrawerClose">
      <div class="comment-view">
        <el-collapse @change="handleCommentCollapseChange">
          <el-collapse-item v-for="(item,index) in commentList" :key="index"
                            :title="'用户'+item.platformUserName+'在'+item.createTime+'的评论'">
            <div class="star-view">视频评分: {{item.starNum}}</div>
            <div class="comment-text-view">{{item.commentText}}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-drawer>
    <!--视频评论-->
    <CommentView ref="commentView" @handleSuccess="commentSuccess"></CommentView>
    <!--用户登录-->
    <VideoTransmitView ref="videoTransmitView"
                       @handleSuccess="transmitVideoSuccess">
    </VideoTransmitView>
  </div>
</template>
<script>
import VideoTransmitView from './VideoTransmitView'
import CommentView from './CommentView'
import PlatformApi from "@/services/platform-user";
export default {
  name: "VideoView",
  props: {
    videoList:{
      type: Array,
      required: true,
      default: () => []
    }
  },
  components:{
    CommentView:CommentView,
    VideoTransmitView:VideoTransmitView,
  },
  data() {
    return {
      //视频评论内容
      commentList:[],
      //视频评论是否展示
      commentDrawerShow: false,
      //视频评论弹出方向
      commentDrawerDirection: 'rtl',
    };
  },
  methods:{
    //删除视频
    handleDeleteVideo(item){
      const loading = this.$loading({
        lock: true,
        text: "正在操作",
      });
      let videoDataId = item.videoDataId
      try {
        PlatformApi.deleteVideo({
          videoDataId:videoDataId
        }).then((res) => {
          console.log('删除视频结果:'+JSON.stringify(res))
          if (res.success) {
            this.$message({
              message: "删除视频成功!",
              type: "success",
            });
            //传递到父组件 刷新界面
            this.$emit('resetCurrentPage',{})
          } else {
            this.$message.error('服务器异常');
          }
        });
        loading.close();
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    //视频点赞
    videoTag(item){
      const loading = this.$loading({
        lock: true,
        text: "正在操作",
      });
      let videoDataId = item.videoDataId
      try {
        PlatformApi.videoTag({
          videoDataId:videoDataId
        }).then((res) => {
          console.log('点赞结果:'+JSON.stringify(res))
          if (res.success) {
            this.$message({
              message: "视频点赞成功!",
              type: "success",
            });
            //传递到父组件 执行查询视频列表
            this.$emit('queryVideoList',{})
          } else {
            this.$message.error('服务器异常');
          }
        });
        loading.close();
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    //查询视频评论
    async queryComment(videoDataId){
      const loading = this.$loading({
        lock: true,
        text: "正在查询评论",
      });
      try {
        PlatformApi.queryComment({
          videoDataId:videoDataId
        }).then((res) => {
          console.log('查询视频评论结果:'+JSON.stringify(res))
          if (res.success) {
            let data = res.data
            if(data && data.length > 0){
              this.commentList = data;
            }
          } else {
            this.$message.error('服务器异常');
          }
        });
        loading.close();
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    //处理视频评论内容展开
    handleCommentCollapseChange(val){
      console.log('handleCommentCollapseChange:'+val)
    },
    //评论成功
    commentSuccess(){
      this.$emit('commentSuccess')
      console.log('评论成功')
    },
    //弹出视频转发
    showVideoTransmit(item){
      console.log('showVideoTransmit:'+JSON.stringify(item))
      this.$refs.videoTransmitView.showTransmit(item)
    },
    //视频转发
    transmitVideoSuccess(){
      console.log('视频转发成功')
    },
    //下载视频
    downloadVideo(item){
      //window.location.href = this.videoItem.url
      window.open(item.videoItem.url)
    },
    //弹出视频评论
    showCommentView(item){
      console.log('showCommentView')
      this.$refs.commentView.showAdd(item);
    },
    //查看评论视频
    async showCommentDrawer(item){
      console.log('showCommentDrawer')
      await this.queryComment(item.videoDataId);
      this.commentDrawerShow = true
    },
    handleDrawerClose(){
      console.log('handleDrawerClose')
      this.commentDrawerShow = false
    },
    handleFullscreen(){},
  },
  computed: {

  },
  created() {

  },
  destroyed() {

  },
}
</script>

<style lang="scss" scoped>
.video-view{
  width: 100%;
  margin: 10px 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .video-item-view{
    width: 50%;
    margin: 10px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: #dadee1;
    top:-100px;
    .publisher-view{
      margin: 5px 5px;
      font-weight: bold;
      font-size: 15px;
    }
    .video-head{
      margin: 5px 5px;
      font-weight: bold;
      font-size: 10px;
      color: #409EFF;
    }
    .video-title{
      margin: 5px 5px;
      font-weight: bold;
      font-size: 15px;
      color: #409EFF;
    }
    .video-title-view{
      margin: 5px 5px;
      font-weight: bold;
      width: 100%;
      //background-color: #d00d3a;

      .video-text{
        font-size: 15px;
      }
    }
    .video-item{

    }
    .video-bottom{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .bottom-show-view{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        .bottom-show-item{
          margin: 10px 10px;
        }
      }
      .bottom-handle-view{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        .bottom-handle-item{
          margin: 10px 10px;
        }
      }
    }
  }
  .comment-view{
    margin: 10px 10px;
    .star-view{
      color: #537be0;
      font-size: 15px;
      font-weight: bold;
    }
    .comment-text-view{
      font-size: 15px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// VideoView.vue?e67a446c